import { SvgIcon } from '@mui/material';
import { IconProps } from './types/iconTypes';
const SquareCrossIcon = ({
  color = '#004EBF',
  width = '24',
  height = '24',
  className
}: IconProps) => <SvgIcon className={className} width={`${width}px`} height={`${height}px`} viewBox={`0 0 ${width} ${height}`} data-sentry-element="SvgIcon" data-sentry-component="SquareCrossIcon" data-sentry-source-file="SquareCrossIcon.tsx">
		<path d="M19 3H5C3.9 3 3.01 3.9 3.01 5L3 19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM18 14H14V18H10V14H6V10H10V6H14V10H18V14Z" fill={color} data-sentry-element="path" data-sentry-source-file="SquareCrossIcon.tsx" />
	</SvgIcon>;
export default SquareCrossIcon;